import { Box } from "@chakra-ui/react"

export const overlayStyles = {
  pos: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  minHeight: "100%",
  minWidth: "100%",
  overflow: "hidden"
} as const

type DotBackgroundProps = {
  dotSize?: number
  dotSpacing?: number
}

const DotBackground = ({
  dotSize = 4,
  dotSpacing = 50
}: DotBackgroundProps) => (
  <Box borderRadius="inherit" {...overlayStyles} className="DotBackground">
    {/* Gradient Overlay - matches legacy version */}
    <Box
      {...overlayStyles}
      borderRadius="inherit"
      bgGradient="to-b"
      gradientFrom="rgba(51, 49, 50, 0.5)"
      gradientTo="rgba(51, 49, 50, 0.8)"
    />

    {/* Dots Pattern */}
    <Box
      {...overlayStyles}
      borderRadius="inherit"
      backgroundImage={`radial-gradient(rgba(255, 255, 255, 0.2) ${
        (dotSize / dotSpacing) * 100
      }%, transparent ${(dotSize / dotSpacing) * 100}%)`}
      backgroundPosition={`0 0, ${dotSpacing / 2}px ${dotSpacing / 2}px`}
      backgroundSize={`${dotSpacing}px ${dotSpacing}px`}
    />
  </Box>
)

DotBackground.displayName = "DotBackground"

export default DotBackground
